// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".css?v=" + {"3811":"61d68192a7fa94f0c6df","5739":"dcda178ee05a7526d5c1"}[chunkId] + "";
};